import { render, staticRenderFns } from "./ScopeOfServices.vue?vue&type=template&id=cef9502a&"
import script from "./ScopeOfServices.vue?vue&type=script&lang=js&"
export * from "./ScopeOfServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports